module.exports = __webpack_public_path__ + "static/carbon-button-danger-f575ea764833fb73cf202424975a2b65.png";